import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Heading from '@bibliocommons/heading';
import { onlineResourceShape } from '@bibliocommons/bc-prop-types';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibHoldingsEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import ResourcesList from 'app/components/bibs/shared/ResourcesList';

const { composeOnlineResourceClickEvent } = bibHoldingsEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

const handleClick = url => {
  sendAnalyticsEvents(
    composeOnlineResourceClickEvent({
      url,
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_RELATED_RESOURCES
    })
  );
};

export default function OnlineResources({ onlineResources }) {
  if (onlineResources.size === 0) return null;

  return (
    <div className="cp-online-resources">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="online_resources" />
      </Heading>
      <ResourcesList resources={onlineResources} handleClick={handleClick} />
    </div>
  );
}

OnlineResources.propTypes = {
  onlineResources: ImmutablePropTypes.listOf(onlineResourceShape).isRequired
};
